import {CalendarEvent, CalendarExporterAbstract} from './calendar-exporter.abstract';

const calendarUrl = 'https://calendar.live.com/calendar/calendar.aspx?rru=addevent';

export class CalendarExporterOutlook extends CalendarExporterAbstract {
  exportForProject(releaseDate: string, projectCode: string): void {
    const calendarEvent = this.getCalendarEventForProjectCode(releaseDate, projectCode);
    this.export(calendarEvent);
  }

  exportForPublication(releaseDate: string, bibCode: string): void {
    const calendarEvent = this.getCalendarEventForBibCode(releaseDate, bibCode);
    this.export(calendarEvent);
  }

  exportForObservation(releaseDate: string, datasetId: string): void {
    const calendarEvent = this.getCalendarEventForObservation(releaseDate, datasetId);
    this.export(calendarEvent);
  }

  private export(calendarEvent: CalendarEvent): void {
    let url = `${calendarUrl}&text=${calendarEvent.title}`;
    url += `&dtstart=${calendarEvent.start}&dtend=${calendarEvent.end}`;
    url += `&summary=${encodeURI(calendarEvent.title)}&location=${encodeURI(calendarEvent.details)}`;
    window.open(url);
  }
}
